import React, { useState, useEffect } from 'react';
import Content from './components/Content';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import AdminDashboard from './components/Admin/AdminDashboard';

function App() {
  const [isAdminMode, setIsAdminMode] = useState(false);

  useEffect(() => {
    // Check if the URL contains ?mode=admin
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get('mode') === 'admin') {
      setIsAdminMode(true);
    }
  }, []);

  if (isAdminMode) {
    return <AdminDashboard />;
  }

  return (
    <div className="App">
      <Navbar/>
      <div className="content">
          <Content />
      </div>
      <Footer/>
    </div>
  );
}

export default App;
